module.exports = __webpack_public_path__ + "img/5.bb842eb3.jpg";